import React from 'react'
import styles from "./styles/courseModuleIconStyles.module.css"
const CourseModuleCardIcon = () => {
    return (
        <svg
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 5.99999C11 5.44771 10.5506 4.99355 10.0026 5.06241C8.77376 5.21682 7.59275 5.65512 6.55544 6.34823C5.23985 7.22728 4.21446 8.47671 3.60896 9.93852C3.00346 11.4003 2.84504 13.0089 3.15372 14.5607C3.4624 16.1126 4.22433 17.538 5.34315 18.6569C6.46197 19.7757 7.88743 20.5376 9.43928 20.8463C10.9911 21.155 12.5997 20.9965 14.0615 20.391C15.5233 19.7855 16.7727 18.7602 17.6518 17.4446C18.3449 16.4072 18.7832 15.2262 18.9376 13.9974C19.0064 13.4494 18.5523 13 18 13H12.5C11.6716 13 11 12.3284 11 11.5V5.99999Z" fill="#8084B3" stroke="#8084B3" stroke-width="1.5" />
            <path d="M14 4C14 3.44772 14.45 2.99268 14.9966 3.07131C15.5731 3.15423 16.1383 3.30896 16.6788 3.53284C17.5281 3.88463 18.2997 4.40024 18.9497 5.05025C19.5998 5.70026 20.1154 6.47194 20.4672 7.32122C20.691 7.86171 20.8458 8.4269 20.9287 9.00339C21.0073 9.55005 20.5523 10 20 10H14.2C14.0895 10 14 9.91046 14 9.8V4Z" fill="#6167A0" stroke="#6167A0" stroke-width="1.5" />
        </svg>



    )
}

export default CourseModuleCardIcon